import { Dialog, DialogPanel } from '@headlessui/react'

export default function Modal({ isOpen, onClose, children, className }) {
  return (
    <Dialog
      open={isOpen}
      onClose={() => onClose()}
      className="relative z-50"
    >
      <div
        className="fixed inset-0 bg-muted-700/50 backdrop-blur"
        aria-hidden="true"
      />
      <div className="fixed inset-0 flex h-screen w-screen items-center justify-center p-4 text-primary-600">
        <DialogPanel className={className}>{children}</DialogPanel>
      </div>
    </Dialog>
  )
}
